import React, { Component } from 'react';
import { Map, GoogleApiWrapper } from 'google-maps-react';
import ReactDOM from 'react-dom';
import { InfoWindow, Marker } from 'google-maps-react';

const mapStyles = {
    width: '100%',
    height: '100%'
};

export class GoogleMapStores extends Component {

    map = {}

    state = {
        showingInfoWindow: true,  //Hides or the shows the infoWindow
        activeMarker: {},          //Shows the active marker upon click
        selectedPlace: {}          //Shows the infoWindow to the selected place upon a marker
    }


    onMarkerClick = (props, marker, e) =>
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });

    onClose = props => {
        if (this.state.showingInfoWindow) {
            this.setState({
                showingInfoWindow: false,
                activeMarker: null
            });
        }
    };

    render() {
        return (

            <Map
                google={this.props.google}
                zoom={this.props.zoom}
                style={mapStyles}
                initialCenter={{
                    lat: this.props.center.lat,
                    lng: this.props.center.lng
                }}
            >
                <Marker
                    onClick={this.onMarkerClick}
                    name={'MIGHTYWIFI'}
                />
                <InfoWindow
                    marker={this.state.activeMarker}
                    visible={this.state.showingInfoWindow}
                    onClose={this.onClose}
                >
                    <div>
                        <strong style={{fontWeight: "700"}}>{this.state.selectedPlace.name}</strong>
                    </div>
                </InfoWindow>
            </Map>
        );
    }
}


export default GoogleApiWrapper({
    apiKey: 'AIzaSyBzljTXd37hf65OY_WBFWh90UkFA1c9c_o'
})(GoogleMapStores);


// API KEY : AIzaSyD8ovPbN9Pi0HoxB2HtSqVU4ypVNZgoqKo


// WEBPACK FOOTER //
// ./src/pages/rent/GoogleMapStores.js